import { Progress, Icon } from '../../styled';
import { BiMessageDetail, BiUser, BiMailSend } from 'react-icons/bi';
import { RiContactsBook2Line } from 'react-icons/ri';

const ProgressSteps = ({ currentStep, onStepClick }) => {
    const steps = [
        { id: 0, icon: BiUser, title: 'Contatos' },
        { id: 1, icon: RiContactsBook2Line, title: 'Listas de Contatos' },
        { id: 2, icon: BiMessageDetail, title: 'Mensagens' },
        { id: 3, icon: BiMailSend, title: 'Enviar' }
    ];

    return (
        <Progress>
            {steps.map(({ id, icon: IconComponent, title }) => (
                <div key={id} className="box--">
                    <Icon 
                        className={currentStep === id ? 'current--' : ''} 
                        onClick={() => onStepClick(id)}
                    >
                        <span>
                            <IconComponent style={{ fontSize: '1.3rem' }} />
                        </span>
                    </Icon>
                    <span className='title--'>{title}</span>
                </div>
            ))}
        </Progress>
    );
};

export default ProgressSteps;